import React from "react";
import "./RecipientRegister.css";
import Footer from "../Footer/Footer";
import NavBar from "../NavBar/NavBar";
import { Link } from "react-router-dom";
import { SERVER_ADDRESS } from "../../../constants";
import approved from "./images/sharp_done_black_24dp.png";
import invalid from "./images/sharp_close_black_24dp.png";

class RecipientRegister extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            username: false,
            email: false,
            name: false,
            password: false,
            verify: false
        }

        this.verifyInput = this.verifyInput.bind(this);
        this.renderVerify = this.renderVerify.bind(this);
        this.checkCleared = this.checkCleared.bind(this);
        this.register = this.register.bind(this);
        this.verifyUsername = this.verifyUsername.bind(this);
        this.verifyEmail = this.verifyEmail.bind(this);
        this.verifyName = this.verifyName.bind(this);
        this.verifyPassword = this.verifyPassword.bind(this);
        this.verifyCheck = this.verifyCheck.bind(this);
    }

    async verifyUsername(username) { 
        let valid = (username.length >=3 && username.length <= 32);
        if(valid) {
            // check if in use        
        }
        return valid;
    }

    verifyEmail(email) { 
        let valid = (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(email));
        if(valid) {
            // check if in use
        }
        return valid;
    }

    verifyName(name) { return name.length >= 1}

    verifyPassword(password) {
        let valid = (password.length >= 8);
        if(valid) {
            valid = (/^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{8,25}$/.test(password));
        }
        return valid;
    }

    verifyCheck(password) {
        let valid = (password.length >= 8);
        if(valid) {
            valid = (password === document.getElementById("registration-password").value);
        }
        return valid;
    }

    async verifyInput(event) {
        let type = event.target.id.split("-")[1];
        let content = event.target.value;
        if(type === "username") {
            if(await this.verifyUsername(content)) {
                this.setState({"username": true});
            } else {
                this.setState({"username": false});
            }
        } else if (type === "email") {
            if(this.verifyEmail(content)) {
                this.setState({"email": true});
            } else {
                this.setState({"email": false});
            }
        } else if (type === "name") {
            if(this.verifyName(content)) {
                this.setState({"name": true});
            } else {
                this.setState({"name": false});
            }
        } else if (type === "password") {
            if(this.verifyPassword(content)) {
                this.setState({"password": true});
            } else {
                this.setState({"password": false});
            }
        } else if (type === "verify") {
            if(this.verifyCheck(content)) {
                this.setState({"verify": true});
            } else {
                this.setState({"verify": false});
            }
        }
    }

    checkCleared() {return (this.state.username && this.state.name && this.state.email && this.state.password && this.state.verify);}

    renderButton() {
        if(this.checkCleared()) {
            return (
                <p className="allowed" onClick={this.register} id="registration-button">Go</p>
            );
        }
        return (
            <p className="disallowed" id="registration-button">Go</p>
        );
    }

    renderVerify(type) {
        if(this.state[type]) {
            return (
                <img className="indicator" src={approved} alt="approved"/>
            )
        }
        return (
            <img className="indicator" src={invalid} alt="invalied"/>
        )
    }

    async register() {
        let rawData = {
            username: document.getElementById("registration-username").value,
            email: document.getElementById("registration-email").value,
            name: document.getElementById("registration-name").value,
            password: document.getElementById("registration-password").value,
            approved: false,
            paid: false
        }
        let data = JSON.stringify(rawData);
        try {
            let result = await fetch(`${SERVER_ADDRESS}/users/register`, {
                method: "POST",
                body: data,
                headers: {
                    "content-type": "application/json",
                    "accept": "application/json"
                }
            })
            if(result) {
                result = await result.json();
            }
            this.props.setUser({
                username: result.username,
                email: result.email,
                name: result.name,
                approved: result.approved,
                paid: result.paid
            });
        } catch(error) {
            console.log(error);
        }
    }

    render() {
        return (
            <div>
                <NavBar/>
                <div id="registration-container">
                    <h3>Register</h3>
                    <table id="registration">
                        <tbody>
                            <tr className="input-container" id="registration-username-container">
                                <td className="input-label">Username:</td>
                                <td>
                                    <input className="input-register" onChange={this.verifyInput} id="registration-username" placeholder="ex: kidsinseats"/>
                                </td>
                                <td>{this.renderVerify("username")}</td>
                            </tr>
                            <tr className="add-bottom input-container">
                                <td className="input-filler"></td>
                                <td>
                                    <p className="input-parameter">Minimum 3 characters. Maximum 32 characters.</p>
                                </td>
                                <td></td>
                            </tr>

                            <tr className="add-bottom input-container" id="registration-email-container">
                                <td className="input-label">Email:</td>
                                <td>
                                    <input className="input-register" onChange={this.verifyInput} id="registration-email" placeholder="ex: kis@gmail.com"/>
                                </td>
                                <td>{this.renderVerify("email")}</td>
                            </tr>

                            <tr className="add-bottom input-container" id="registration-name-container">
                                <td className="input-label">Name:</td>
                                <td>
                                    <input className="input-register" onChange={this.verifyInput} id="registration-name" placeholder="ex: John Doe"/>
                                </td>
                                <td>{this.renderVerify("name")}</td>
                            </tr>

                            <tr className="input-container" id="registration-password-container">
                                <td className="input-label">Password:</td>
                                <td>
                                    <input type="password" className="input-register" onChange={this.verifyInput} id="registration-password" placeholder="ex: kis4ever!"/>
                                </td>
                                <td>{this.renderVerify("password")}</td>
                            </tr>
                            <tr className="add-bottom input-container">
                                <td className="input-filler"></td>
                                <td>
                                    <p className="input-parameter">Minimum 8 characters. Maximum 25 characters. Minimum one letter, number, and special character.</p>
                                </td>
                                <td></td>
                            </tr>

                            <tr className="input-container" id="registration-verify-container">
                                <td className="input-label">Verify Password:</td>
                                <td>
                                    <input type="password" className="input-register" onChange={this.verifyInput} id="registration-verify" placeholder="ex: kis4ever!"/>
                                </td>
                                <td>{this.renderVerify("verify")}</td>
                            </tr>
                        </tbody>
                    </table>
                    {this.renderButton()}
                    <p>Already have an account? <Link to="/login">Login</Link></p>
                </div>
                <Footer/>
            </div>
        );
    }
}

export default RecipientRegister;